import { useState } from 'react';

const faqList = [
  {
    q: 'Что такое управление конфликтами в коллективе?',
    a: 'Управление конфликтами — это практический управленческий навык: вовремя замечать напряжение, понимать причины конфликта, организовывать разговор между сторонами и переводить ситуацию в конкретное решение и рабочие договорённости. Задача руководителя — не избегать разногласий, а не давать им разрушать результат команды.',
  },
  {
    q: 'Почему возникают конфликты между сотрудниками?',
    a: 'Чаще всего конфликты возникают из-за неясных зон ответственности, разных целей и KPI подразделений, неясных ожиданий, недостатка коммуникации, несправедливого распределения нагрузки или ресурсов, а также из-за изменений и ошибок руководителя. Поэтому важно искать не «виноватого», а реальную причину конфликта.',
  },
  {
    q: 'Как руководителю правильно разрешать конфликт?',
    a: 'Сначала руководитель диагностирует ситуацию: кто участники, в чём их интересы и что является реальной проблемой. Затем отделяет факты от оценок, выслушивает обе стороны, помогает сформулировать суть разногласия и переводит разговор в поиск решения. В завершение важно зафиксировать договорённости: конкретные действия, сроки и ответственность, а затем проверить их выполнение.',
  },
  {
    q: 'Нужно ли руководителю вмешиваться в конфликт сотрудников?',
    a: 'Не всегда. Если разногласие рабочее и стороны способны договориться самостоятельно, руководителю достаточно задать правила обсуждения. Вмешиваться нужно, когда конфликт повторяется, влияет на результат, переходит в открытое противостояние или затрагивает системные проблемы компании. Важно определить масштаб ситуации, а не решать всё за сотрудников.',
  },
  {
    q: 'Какие бывают виды конфликтов в коллективе?',
    a: 'Можно выделить рабочее разногласие, конструктивную дискуссию, межличностный конфликт, конфликт интересов, конфликт из-за распределения ответственности, конфликт между сотрудником и руководителем и конфликт между подразделениями. Каждый тип требует своего подхода: что-то решается переговором сторон, что-то — вмешательством руководителя или пересмотром правил.',
  },
  {
    q: 'Как научиться проводить сложные разговоры?',
    a: 'Сложный разговор — это навык, который отрабатывается: начинать разговор без обвинений, говорить о конкретном поведении и его последствиях, задавать вопросы и слушать ответы, сохранять конструктивный тон при эмоциональной реакции собеседника. На тренинге участники практикуются на реальных ситуациях и получают обратную связь по своей коммуникации.',
  },
  {
    q: 'Можно ли научить сотрудников конструктивно разрешать конфликты?',
    a: 'Да. Сотрудников учат отделять факты от оценок, формулировать суть проблемы, слушать собеседника, искать общее решение и фиксировать договорённости. Но устойчивый результат появляется тогда, когда эти навыки поддерживаются управленческой системой: понятными правилами, зонами ответственности и регулярной обратной связью.',
  },
  {
    q: 'Сколько длится тренинг по управлению конфликтами?',
    a: 'Корпоративный тренинг обычно занимает 1–2 дня практической работы. Модульная программа может длиться несколько недель с практикой между модулями, а управленческая программа — несколько месяцев. Точный формат и продолжительность определяются после диагностики потребностей и обсуждения задач компании.',
  },
  {
    q: 'Можно ли адаптировать программу под реальные конфликты нашей компании?',
    a: 'Да, адаптация — обязательный этап подготовки. Мы не используем шаблонные решения. Сначала разбираемся в реальных конфликтных ситуациях компании: между какими сотрудниками и подразделениями возникают споры, каковы их причины. После этого программа настраивается под специфику бизнеса, а реальные кейсы компании встраиваются в отработку.',
  },
  {
    q: 'Подходит ли тренинг новым руководителям?',
    a: 'Да, для новых руководителей тренинг особенно полезен. Они часто впервые сталкиваются с необходимостью разбирать конфликты между бывшими коллегами, проводить сложные разговоры и выдерживать управленческую позицию. Программа даёт базовые инструменты диагностики конфликта и практическую отработку, которая помогает быстрее освоить новую роль.',
  },
  {
    q: 'Можно ли включить управление конфликтами в программу обучения руководителей?',
    a: 'Да, управление конфликтами может быть отдельным модулем комплексной программы развития руководителей. Оно естественно сочетается с темами обратной связи, делегирования, мотивации и управления изменениями. Формат подбирается под цели компании и уровень участников.',
  },
  {
    q: 'Что происходит после тренинга?',
    a: 'После обучения участники применяют инструменты в реальной работе. При необходимости мы проводим сопровождение: разбираем конкретные конфликтные ситуации, которые возникли после тренинга, помогаем скорректировать действия и закрепить навыки. При системной работе определяется, изменилось ли управленческое поведение и качество взаимодействия в команде.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Часто задаваемые вопросы
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-14 max-w-3xl mx-auto leading-relaxed">
          Ответы на ключевые вопросы об управлении конфликтами в коллективе
        </p>

        <div className="space-y-4">
          {faqList.map((item, i) => (
            <div key={i} className="bg-white rounded-xl border border-gray-200 overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <span className="font-bold text-gray-900 pr-4 text-sm md:text-base">{item.q}</span>
                <i className={`ri-arrow-down-s-line text-xl text-teal-600 flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-180' : ''}`}></i>
              </button>
              <div className={`px-6 pb-5 ${openIndex === i ? '' : 'hidden'}`}>
                <p className="text-gray-600 leading-relaxed text-sm md:text-base">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}